<template>
    <div id="wrap" class="landing_wrap pb-0">
        <div class="dim"></div>
        <div class="container_wrap">
            <!-- Loading -->
            <div class="loader_table">
                <div class="loader_box">
                    <div class="loader">
                        <span class="sr_only">Loading...</span>
                    </div>
                </div>
                <p v-if="!isError">Loading</p>
                <p v-else v-html="errorMsg"></p>
            </div>
            <!-- //Loading -->
        </div>
        <keep-alive>
            <recommend-pop />
        </keep-alive>
    </div>
</template>
<script>
import Vue                          from 'vue';
import axios                        from 'axios';
import store                        from '@/vuex/store';
import { mapGetters, mapActions }   from 'vuex';
import SDLUtil                      from '@/utils/SDLUtil';
import StringUtil                   from '@/utils/StringUtil';

import RecommendPopup               from '~vb/common/RecommendPopup';
import KnowledgeContentsPopup       from '~vb/knowledge/popup/KnowledgeContentsPopup';

export default {
    name: 'Register',
    data() {
        return {
            isError : false,
            errorMsg : SDLUtil.getMsgProp('MESSAGE.USERMNG.INSERT.ERROR')
        }
    },
    computed: {
        ...mapGetters({
            userRoles   : 'getRoles',
            userCorpCd  : 'getCorpCd',
            popupParams : 'getPopupParams',
        }),
    },
    components : {
        'recommend-pop' : RecommendPopup
    },
    methods: {
        ...mapActions(['logout']),
    },
    created() {
        const self = this;
        const params = store.getters.getPopupParams || {};
        const isSCMSDirect = StringUtil.isNull(params.cttType) ? false : true;

        // SCMS에서 편집모드로 접근 시, KnowledgeId 가 없으면 팝업을 호출하지 않는다.
        if(isSCMSDirect && params.isModify && SDLUtil.isNull(params.knowledgeId)) {
            this.isError = true;
            SDLUtil.alert({
                title: 'TITLE.WARNING.TITLE',
                msg: 'MESSAGE.PROGRAM.END',
                onOkEvt: () => { window.close(); },
                onCancelEvt: () => { window.close(); },
            });

        } else {
            SDLUtil.show(
                KnowledgeContentsPopup,
                {
                    title: params.title                                         || SDLUtil.getMsgProp('TITLE.KNOWLEDGE.DETAIL'),
                    knowledgeId: params.knowledgeId                             || '',
                    boardId: params.boardId                                     || '',
                    boardType1: params.boardType1                               || '',
                    boardType2: params.boardType2                               || '',
                    isModify: params.isModify                                   || false,
                    // View 전용
                    isOnlyView: params.isOnlyView                               || false,
                    // SCMS 전용
                    isSCMSDirect:    isSCMSDirect,
                    cttType:         String(params.cttType).toUpperCase()       || '',
                    scmsModelCd:     String(params.scmsModelCd).toUpperCase()   || '',
                    scmsModelGbmCd:  String(params.scmsModelGbmCd).toUpperCase()|| '',
                    scmsEcnNo:       String(params.scmsEcnNo).toUpperCase()     || '',
                    scmsCategoryCd1: String(StringUtil.nvl(params.categoryCd1)).toUpperCase()   || '',
                    scmsCategoryCd2: String(StringUtil.nvl(params.categoryCd2)).toUpperCase()   || '',
                    scmsCategoryCd3: String(StringUtil.nvl(params.categoryCd3)).toUpperCase()   || '',
                    // 버그 리포트 전용
                    isBugReport: params.isBugReport                             || false,
                    bugReportId: params.bugReportId                             || '',
                    // Admin 전용
                    isAdminMenu: params.isAdminMenu                             || false,
                    adminButtonAuth: params.adminButtonAuth                     || false,
                    adminMenuType: params.adminMenuType                         || '',
                    // Service Script 전용
                    isServiceScript: params.isServiceScript                     || false,
                    serviceScriptId: params.serviceScriptId                     || '',
                    serviceScriptType: params.serviceScriptType                 || '',
                    // Request Sharing 전용
                    isRequestSharing: params.isRequestSharing                   || false,
                    shareId: params.shareId                                     || '',
                    requesterId: params.requesterId                             || '',
                    reProcessCorpNo: params.reProcessCorpNo                     || '',

                    rtnFunc: (data) => {
                        Vue.$log.info('▶ Register.vue rtnFunc =>', data);
                        // data : { flag : '' }
                        // Delete a Knowledge detail or Not found Knowledge detail
                        store.commit('POPUP_PARAMS', {});

                        if(data.flag === 'DKD') {
                            Vue.$log.info('▶ Register.vue -> Delete a Knowledge detail.');

                        } else if(data.flag === 'EKD') {
                            Vue.$log.info('▶ Register.vue -> Expire Knowledge details.');

                        } else if(data.flag === 'NFK') {
                            Vue.$log.warn('▶ Register.vue -> Knowledge Detail not found exception!');

                        } else if(data.flag === 'BUG') {
                            Vue.$log.info('▶ Register.vue -> Knowledge Detail modify complete.');

                        } else if(data.flag === 'ADM') {
                            Vue.$log.info('▶ Register.vue -> Admin Knowledge status change complete.');

                        } else {
                            Vue.$log.info('▶ Register.vue -> KnowledgeContentsPopup.vue close...');
                        }

                        let winPop = window.open("about:blank", "_self");
                            winPop.close();
                    }
                },
                { name: 'ContentsPopup', width: '100%', height: '100%' }, //, minWidth: Number(1100), adaptive: true },
                // 팝업 닫은 후 실행될 이벤트
                {
                    closed: () => {
                        this.$nextTick(() => { window.close(); });
                    }
                }
            );
        }
    },
    mounted() {
        /*
         * 윈도우 팝업이 닫힐 때, 이벤트를 캐치한다.
         * IE에서는 정상적으로 작동, 타 브라우저에서는 focus 문제로 강제로 닫히는 현상이 있음.
         */
        let closingWindow = false;
        $(window).on('focus', function () {
            closingWindow = false;
            //if the user interacts with the window, then the window is not being
            //closed
        });

        $(window).on('blur', function () {
            closingWindow = true;
            if (!document.hidden) {
                //when the window is being minimized
                closingWindow = false;
            }

            $(window).on('resize', function (e) {
                //when the window is being maximized
                closingWindow = false;
            });

            $(window).off('resize');
                //avoid multiple listening
        });

        $('html').on('mouseleave', function () {
            closingWindow = true;
            //if the user is leaving html, we have more reasons to believe that he's
            //leaving or thinking about closing the window
        });

        $('html').on('mouseenter', function () {
            closingWindow = false;
            //if the user's mouse its on the page, it means you don't need to logout
            //them, didn't it?
        });

        $(document).on('keydown', function (e) {
            if (e.keyCode == 91 || e.keyCode == 18) {
                closingWindow = false; //shortcuts for ALT+TAB and Window key
            }

            if (e.keyCode == 116 || (e.ctrlKey && e.keyCode == 82)) {
                closingWindow = false; //shortcuts for F5 and CTRL+F5 and CTRL+R
            }
        });

        // Prevent logout when clicking in a hiperlink
        $(document).on("click", "a", function () {
            closingWindow = false;
        });

        // Prevent logout when clicking in a button (if these buttons rediret to some page)
        $(document).on("click", "button", function () {
            closingWindow = false;
        });

        // Prevent logout when submiting
        $(document).on("submit", "form", function () {
            closingWindow = false;
        });

        // Prevent logout when submiting
        $(document).on("click", "input[type=submit]", function () {
            closingWindow = false;
        });

        window.addEventListener("beforeunload", function (e) {
            if (closingWindow) {
                let msg = SDLUtil.getMsgProp('MESSAGE.POPUP.CLOSE');
                e.preventDefault();
                e.returnValue = msg;
                return msg;
            }
        });

    },
    beforeDestroy() {
        // 팝업창 닫을 시 POPUP_PARAMS 초기화
        store.commit('CONN_SYSTEM', '');
        store.commit('POPUP_PARAMS', {});
    }
};
</script>

<style>
.pb-0 {padding-bottom: 0px !important;}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/Register.vue